import { AppRoutes, SearchParams } from '@constants';
import { guestListPath, isGuestShare } from './guestShare';

export const isSamePage = (locationPathname: string, appRoute: string) =>
  locationPathname.includes(appRoute);

export const candidateDetailsPath = (
  candidateId: string,
  listSearch: string,
) => {
  const view = listSearch.replace(/^\?/, '');

  return `${listBase()}/${candidateId}${view ? `?v=${encodeURIComponent(view)}` : ''}`;
};

export const candidatesListPath = (detailsSearch: string) => {
  const view = new URLSearchParams(detailsSearch).get('v');

  return `${listBase()}${view ? `?${view}` : ''}`;
};

/** A guest moves between the same pages under their share link. */
const listBase = () =>
  isGuestShare() ? guestListPath() : `/${AppRoutes.CANDIDATES}`;

export const sharePath = (submissionId: string) =>
  `/${AppRoutes.SHARE}?${SearchParams.SUBMISSION}=${encodeURIComponent(submissionId)}`;
